const initialState = {
  loading: false,
  success: false,
  error: false,
  articleListing: [],
  totalArticle: 0,
  articleDetail: null,
  categories: []
};

const articleReducer = (state = initialState, action) => {
  switch (action.type) {

    case "ADD_ARTICLE_REQUEST":
    case "GET_ARTICLE_REQUEST":
      return {
        ...state,
        loading: true,
        error: false
      };

    case "ADD_ARTICLE_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true
      };

    case "ADD_ARTICLE_FAILED":
    case "GET_ARTICLE_REQUEST_FAILED":
      return {
        ...state,
        loading: false,
        error: true
      };

    case "GET_ARTICLE_REQUEST_SUCCESS":
      return {
        ...state,
        loading: false,
        articleListing: action.payload,
        totalArticle: action.total
      };

    case "SET_ARTICLE_DETAIL":
      return {
        ...state,
        articleDetail: action.payload
      };

    case "SET_ARTICLE_CATEGORIES":
      return {
        ...state,
        categories: action.payload
      };

    default:
      return state;
  }
};

export default articleReducer;